<p-modal-confirm
    [title]="'La sesión expiró'"
    [icon]="'warning'"
    [subtitle]="'Ha sobrepasado el tiempo permitido. Inicie sesión nuevamente.'"
    [titleButton]="'Entendido'"
    (onClose)="onClose()"
    [isVisible]="true"
></p-modal-confirm>
